import {useFilterByLicense} from '@/biz/license.jsx'

export default () => {
    const filterByLicense = useFilterByLicense()

    return {
        title: '项目管理',

        children: [
            filterByLicense('M00010004', {
                title: '项目',
                to: ['/ProjectList'],
            }),

            //{
                //title: '业务需求单',
                //to: ['/RequirementFormList'],
            //},

            //filterByLicense('M00030006', {
                //title: '结构化需求单',
                //to: ['/BrfList'],
            //}),

            {
                title: '软件SPEC单',
                to: ['/IsrfList'],
            },

            // filterByLicense('M00030007', {
            //     title: '需求确认单',
            //     to: ['/DesList'],
            // }),
            //
            // filterByLicense('M00030008', {
            //     title: '系统变更单',
            //     to: ['/ChgList'],
            // }),

            filterByLicense('M00030009', {
                title: '系统上线单',
                to: ['/PrdVersionList'],
            }),

            {
                title: '影响范围分析任务清单',
                to: ['/RequirementImpactedAnalysisList'],
            },

        ],
    }
}
